import React from 'react';
import LoadingComponent from '../../components/LoadingComponent';
import MenuItem from './MenuItem';

type MenuProps = {
  onClick?: () => void;
  onChange: (isShow: boolean) => void | typeof isShow;
  loading?: React.RefObject<LoadingComponent | null>;
};

/**
 * Component of react in menu
 */
export default class Menu extends React.Component<MenuProps> {
  private menu = React.createRef<HTMLUListElement>();

  public toggle(): void {
    this.menu.current?.classList.toggle('show');
    this.props.onChange(this.isShow());
  }

  public isShow(): boolean {
    return Boolean(this.menu.current?.classList.contains('show'));
  }

  public close(): void {
    this.menu.current?.classList.remove('show');
    this.props.onChange(this.isShow());
    if (!this.props.onClick) return;
    this.props?.onClick();
  }

  /**
   * @returns {JSX.Element}
   */
  render(): JSX.Element {
    return (
      <ul className="menu nav justify-content-center" ref={this.menu}>
        <MenuItem
          loading={this.props.loading}
          key="images"
          title="Images"
          url="/"
          onClick={() => this.close()}
        />
        <MenuItem
          loading={this.props.loading}
          key="360"
          title="360"
          url="/360"
          onClick={() => this.close()}
        />
        <MenuItem
          loading={this.props.loading}
          key=""
          title="Animations"
          url="/animations"
          onClick={() => this.close()}
        />
        <MenuItem
          loading={this.props.loading}
          key="contact"
          title="Contact"
          url="/contact"
          onClick={() => this.close()}
        />
        <MenuItem
          loading={this.props.loading}
          key="about"
          title="About"
          url="/about"
          onClick={() => this.close()}
        />
        <MenuItem
          loading={this.props.loading}
          key="join-us"
          title="Join Us"
          url="/join-us"
          onClick={() => this.close()}
        />
      </ul>
    );
  }
}
